export const bulkUpdate = (param, val, bulk) => {
    if (!param) {
        return bulk;
    }
    let {id, value} = param.set(val, true, true);
    bulk[id] = value;
    return bulk;
}
